import React from 'react';
import { OpForm } from 'components/customAntd/DLS/OpForm/OpForm';
import { DATE_FORMAT } from 'constants/dates';
import { useTranslation } from 'react-i18next';

const VisitorForm: React.FC = () => {
    const { t } = useTranslation();
    return (
        <>
            <OpForm.Input
                label={t('redFlag.form.firstName')} name={['visitor', 'firstName']} rules={[{ required: true, message: t('redFlag.form.firstNameRequired') }]}
            />

            <OpForm.Input
                label={t('redFlag.form.lastName')} name={['visitor', 'lastName']} rules={[{ required: true, message: t('redFlag.form.lastNameRequired') }]}
            />

            <OpForm.Input
                label={t('redFlag.form.middleName')} name={['visitor', 'middleName']}
            />

            <OpForm.DatePicker format={DATE_FORMAT} label={t('redFlag.form.dateOfBirth')} name={['visitor', 'dateOfBirth']} />

            <OpForm.Input
                label={t('redFlag.form.identification')} name={['visitor', 'identification']}
            />
        </>
    );
};

export default VisitorForm;
